import React from 'react';
import styles from './Form.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Form = ({ className, children, ...props }) => {
  return (
    <section className={classNames(styles.section, className)} {...props}>
      {children}
    </section>
  );
};

Form.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Form.defaultProps = {
  className: null,
  children: null,
};

export default Form;
